<template>

  <RiepilogoMensileRid />
 
</template>

<script>
import RiepilogoMensileRid from '../components/pratiche/RiepilogoMensileRid.vue'

export default {
  pageName: 'fatture',
  components: {
    RiepilogoMensileRid

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
